export const ImpactAndRiskColors = {
  'Very High': '#CF3D3D',
  'High': '#B75E0B',
  'Medium': '#3E70D4',
  'Low': '#238914',
  'Missing Data': '#3C4F55'
};